"use strict";
(function (global) {
    // deklaracja klasy
    // noinspection JSPotentiallyInvalidConstructorUsage
    class Control {
        constructor(config) {
            this.gridId = null;
            this.showAllRows = null;
            this.containerId = null;
            this.dataSource = null;
            this.reloadTime = 0;
            this.columnDefinitionSource = null;
            this.settingsManager = null;
            this.grid = null;
            this.gridDataProcessor = null;
            this.autoLoad = false;
            this.pageSize = 40;
            this.listeners = {};
            this.allowMultiselect = false;
            this.enableMultiline = false;
            this.loadCallback = null;

            this.init(config);
        }

        /**
         * Listener obsługujący zdarzenie edycji komórki.
         * W fazie 0, czyli przed rozpoczęciem edycji, następuje weryfikacja, czy komórka jest dostępna dla edycji.
         *
         * Weryfikacja następuje na podstawie 2 opcji konfiguracji definicji kolumn - isEditable i isEditableOnAdd.
         * Pierwsza umożliwia edycję rekordu istniejącego, druga umożliwia edycję nowego, niezapisanego rekordu.
         *
         * @param stage - faza edycji, 0 - przed, 1 - otwarcie edytora, 2 - zakończenie edycji
         * @param rowId - identyfikator wiersza
         * @param cellIndex - index komórki
         * @param value - nowa wartość (etap 2)
         * @param oldValue - stara wartość (etap 2)
         * @returns {boolean}
         */
        onEditCell(stage, rowId, cellIndex, value, oldValue) {
            const columnId = this.grid.getColumnId(cellIndex);
            const columnDefinition = this.columnDefinitionSource.getByDataIndex(columnId);

            let isEditable;

            if (this.gridDataProcessor.getState(rowId) === "inserted") {
                isEditable = !!columnDefinition.isEditableOnAdd;
            } else {
                isEditable = !!columnDefinition.isEditable;
            }

            return isEditable;
        }

        /**
         * Obsługa eventu o zmianie zaznaczenia i triggerowanie tablicy z identyfikatorami DHTMLX-owych wierszy.
         *
         * @param id - identyfikator (null, lub string z identyfikatorami przedzielonymi przecinkami - patrz: DHTMLX this.grid api)
         */
        onSelectStateChanged(id) {
            if (id === null) {
                this.trigger("onSelectionChange", []);
            } else {
                const idsArray = id.split(",");
                this.trigger("onSelectionChange", idsArray);
            }
        }

        getSelectedRowIds() {
            let idsArray = [];
            const id = this.grid.getSelectedRowId();

            if (id !== null) {
                idsArray = id.split(",");
            }

            return idsArray.length > 0 ? idsArray[0] : null;
        }

        /**
         * Listener
         * @param columnIndex
         * @param dhtmlXGridObject this.gridObj
         * @param direction
         * @returns {boolean}
         */
        onBeforeSorting(columnIndex, dhtmlXGridObject, direction) {
            const columnDataIndex = this.grid.getColumnId(columnIndex);

            const columnDefinition = this.columnDefinitionSource.getByDataIndex(columnDataIndex);

            this.dataSource.orderBy(columnDefinition.dataIndex, direction);

            this.settingsManager.set(this.gridId + "_sort_column", columnDataIndex);
            this.settingsManager.set(this.gridId + "_sort_direction", direction);
            this.settingsManager.save();

            this.load();

            return false;
        }

        /**
         * @param _ Indeks przesuwanej kolumny
         * @param posIndex Indeks nowej pozycji
         */
        onAfterColumnMove(_, posIndex) {
            for (let columnIndex = 0; columnIndex < this.columnDefinitionSource.count(); columnIndex++) {
                const columnDataIndex = this.grid.getColumnId(columnIndex);
                this.settingsManager.set(this.gridId + "_" + columnDataIndex + "_position", columnIndex);
            }

            this.settingsManager.save();

            return true;
        }

        /**
         * @param columnIndex
         * @param hidden
         */
        onColumnHidden(columnIndex, hidden) {
            const columnDataIndex = this.grid.getColumnId(columnIndex);
            this.settingsManager.set(this.gridId + "_" + columnDataIndex + "_hidden", hidden);
            this.settingsManager.save();
        }

        /**
         * @param columnIndex
         * @param width
         */
        onColumnResize(columnIndex, width) {
            const columnDataIndex = this.grid.getColumnId(columnIndex);

            this.settingsManager.set(this.gridId + "_" + columnDataIndex + "_width", parseInt(width));

            return true;
        }

        /**
         * Powiadomienie o zakończeniu zmiany rozmiaru kolumny - zapisujemy ustawienia.
         *
         * @param gridObject
         */
        onColumnResizeEnd(gridObject) {
            this.settingsManager.save();
            return true;
        }

        onLoadStart() {
            this.maskMe(true);
        }

        onLoadEnd() {
            this.maskMe(false);
        }

        /**
         * Funkcja zastępująca domyślne filtrowanie this.grida.
         *
         * UWAGA: W przypadku filtrowania, wykorzystywana jest metoda getFilterElement, która działa na indeksie kolumny,
         * czyli na jej numerze, ale ustawionym na początku. Czyli np. po przesunięciu kolumny (zmianie kolejności)
         * getFilterElement i tak przyjmuje index z przed przesunięcia.
         *
         */
        filterGrid() {
            const values = [];

            let columnIndex = 0;
            const len = this.columnDefinitionSource.count();
            for (; columnIndex < len; columnIndex++) {
                const input = this.grid.getFilterElement(columnIndex);
                const value = input ? input.value : null;

                const columnDefinition = this.columnDefinitionSource.getByIndex(columnIndex);

                if (value) {
                    values.push({
                        "dataIndex": columnDefinition.dataIndex,
                        "value": value
                    });
                }
            }

            this.dataSource.filterBy(values);
            this.load();
        }

        /**
         * Maskowanie kontrolki za pomocą elementu o id this.containerId + "-mask".
         * @param show
         */
        maskMe(show) {
            const loadingMask = document.getElementById(this.containerId + "-mask");

            if (show) {
                loadingMask.style.display = "block";
            }
            else {
                loadingMask.style.display = "none";
            }
        }

        /**
         * Aktualizacja this.grida o ustawienia zapisane w managerze.
         */
        applySettings() {
            //pozycje, według których poustawiamy kolumny
            const positions = [];
            const widths = {};
            const hiddenColumns = {};

            for (let columnIndex = 0; columnIndex < this.columnDefinitionSource.count(); columnIndex++) {
                const columnDefinition = this.columnDefinitionSource.getByIndex(columnIndex);
                const dataIndex = columnDefinition.dataIndex;

                const width = this.settingsManager.get(this.gridId + "_" + dataIndex + "_width", -1);
                const position = this.settingsManager.get(this.gridId + "_" + dataIndex + "_position", -1);
                const hidden = this.settingsManager.get(this.gridId + "_" + dataIndex + "_hidden", false);

                if (position >= 0) {
                    positions[position] = dataIndex;
                }

                if (width > 0) {
                    widths[dataIndex] = width;
                }

                hiddenColumns[dataIndex] = hidden;
            }

            for (const position in positions) {
                if (!positions.hasOwnProperty(position)) {
                    continue;
                }

                const dataIndex = positions[position];
                const columnIndex = this.grid.getColIndexById(dataIndex);
                this.grid.moveColumn(columnIndex, position);
            }

            for (const dataIndex in widths) {
                const width = widths[dataIndex];
                const columnIndex = this.grid.getColIndexById(dataIndex);

                this.grid.setColWidth(columnIndex, parseInt(width) + "px");
            }

            for (const dataIndex in hiddenColumns) {
                const hidden = hiddenColumns[dataIndex];
                const columnIndex = this.grid.getColIndexById(dataIndex);

                this.grid.setColumnHidden(columnIndex, hidden);
            }
        }

        createGrid() {
            if (this.grid !== null) {
                throw new Error("Grid already exists.");
            }

            const gridContainerWidth = document.getElementById(this.containerId).offsetWidth;
            const defaultColumnWidth = parseInt(gridContainerWidth / this.columnDefinitionSource.count());

            //Poniższa konfiguracja musi być wywołana we wskazanej kolejności - chociażby dla tego, żeby
            //uwzględnić ustawianie wyrównywania wartości w kolumnach (setColAlign)
            this.grid = new dhtmlXGridObject(this.containerId + "-this.gridbox");
            this.grid.setColumnIds(this.createColumnsConfiguration("dataIndex", {}));
            this.grid.setHeader(this.createHeaderConfiguration());
            this.grid.setColAlign(this.createColumnsAlignConfiguration());
            this.grid.setColTypes(this.createColumnsTypeConfiguration());
            this.grid.setInitWidths(this.createColumnsConfiguration("width", {}, defaultColumnWidth));
            this.grid.setColumnMinWidth(this.createColumnsConfiguration("minWidth", {}, 40));
            this.grid.enableValidation(true);
            this.grid.enableColumnMove(true, this.createColumnsConfiguration("isMovable", {
                true: "true",
                false: "false"
            }));
            this.grid.setColSorting(this.createColumnsConfiguration("isSortable", {
                true: "server",
                false: "na"
            }));
            this.grid.attachHeader(this.createColumnsConfiguration("isFilterable", {
                true: "#text_filter",
                false: "&nbsp"
            }));


            if (this.allowMultiselect) {
                this.grid.enableMultiselect(true);
            }

            if (this.enableMultiline) {
                this.grid.enableMultiline(true);
            }

            this.grid.setDateFormat("%Y-%m-%d %H:%i:00", "%Y-%m-%d %H:%i");


            if (!this.showAllRows) {
                this.initPaging();
            }


            this.grid.enableAutoHeight(true);

            this.grid.setImagesPath("/images/app/vendor/dhtmlx/");
            this.grid.init();
            this.grid.setStyle(null, "color:red;", null, null);

            this.applySettings();

            //włączenie opcji ukrywania / pokazywania kolumn
            this.grid.enableHeaderMenu();

            const me = this;

            //podpięcie eventów
            this.grid.attachEvent("onBeforeSorting", function (id, type, direction) {
                return me.onBeforeSorting(id, type, direction);
            });
            this.grid.attachEvent("onAfterCMove", function (columnIndex, newPosition) {
                return me.onAfterColumnMove(columnIndex, newPosition);
            });
            this.grid.attachEvent("onColumnHidden", function (columnIndex, state) {
                return me.onColumnHidden(columnIndex, state);
            });
            this.grid.attachEvent("onResize", function (cellIndex, cellWidth, gridObject) {
                return me.onColumnResize(cellIndex, cellWidth, gridObject);
            });
            this.grid.attachEvent("onResizeEnd", function (gridObject) {
                return me.onColumnResizeEnd(gridObject);
            });
            this.grid.attachEvent("onXLS", function (gridObject) {
                return me.onLoadStart(gridObject);
            });
            this.grid.attachEvent("onXLE", function (gridObject, addedRowsCount) {
                return me.onLoadEnd(gridObject, addedRowsCount);
            });
            this.grid.attachEvent("onEditCell", function (stage, rowIndex, cellIndex, newValue, oldValue) {
                return me.onEditCell(stage, rowIndex, cellIndex, newValue, oldValue);
            });
            this.grid.attachEvent("onSelectStateChanged", function (id) {
                return me.onSelectStateChanged(id);
            });
            this.grid.attachEvent("onPageChanged", function (calendar, rowIndex, columnIndex) {
                //TODO: implementacja grupowania
                //me.grid.groupBy(4);
            });

            //przesłonięcie standardowych funkcji this.grida
            this.grid.filterByAll = function () {
                me.filterGrid();
            }
        }

        prepareDom() {
            const gridContainer = document.getElementById(this.containerId);

            const gridContainerGridBox = document.createElement('div');
            gridContainerGridBox.id = this.containerId + "-this.gridbox";
            gridContainerGridBox.style.width = "100%";
            gridContainerGridBox.style.height = "100%";

            const gridContainerPagingBox = document.createElement('div');
            gridContainerPagingBox.id = this.containerId + "-pagingbox";

            const loadingMask = document.createElement("div");
            loadingMask.id = this.containerId + "-mask";
            loadingMask.className = "loading-overlay";

            const loadingIcon = document.createElement("span");
            loadingIcon.className = "loading";

            loadingMask.appendChild(loadingIcon);

            gridContainer.appendChild(gridContainerGridBox);
            gridContainer.appendChild(gridContainerPagingBox);
            gridContainer.appendChild(loadingMask);
        }

        load() {
            if (!this.dataSource) {
                throw new Error("No data source defined.");
            }

            this.grid.clearAll();
            const g = this.grid;

            if (this.loadCallback !== null) {
                g.load(this.dataSource.prepareUrl(), () => {
                    this.loadCallback(g);
                }, 'js');
            } else {
                g.load(this.dataSource.prepareUrl(), 'js');
            }

            //TODO: implementacja grupowania
            //this.grid.groupBy(4);
            const orderBy = this.dataSource.getOrderBy();
            if (orderBy.dataIndex && orderBy.order) {
                const columnIndex = this.grid.getColIndexById(orderBy.dataIndex);
                this.grid.setSortImgState(true, columnIndex, orderBy.order);

            }
        }

        createDataProcessor() {
            if (this.dataSource.getUpdateUrl() === null) {
                return;
            }

            const me = this;
            const url = this.dataSource.getUpdateUrl();

            this.gridDataProcessor = new dataProcessor(url);
            this.gridDataProcessor.init(this.grid);
            this.gridDataProcessor.setTransactionMode("REST", true);
            this.gridDataProcessor.setUpdateMode("off");
            this.gridDataProcessor.enableDataNames(true);
            this.gridDataProcessor.attachEvent("onRowMark", function () {
                me.trigger("onDataChanged");

                return true;
            });
            this.gridDataProcessor.attachEvent("onFullSync", function () {
                me.trigger("onDataSaved");
                me.load();
                return true;
            });
            this.gridDataProcessor.attachEvent("onAfterUpdate", function (id, action, tid, response) {
                if (action === "invalid") {
                    const errors = response.errors ? response.errors : {};

                    for (let dataIndex in errors) {
                        if (!errors.hasOwnProperty(dataIndex)) {
                            continue;
                        }

                        const columnIndex = me.grid.getColIndexById(dataIndex);
                        const cell = me.grid.cells(id, columnIndex);
                        cell.setBgColor("#ffaaaa");
                    }

                    me.trigger("onDataInvalid");
                } else if (action === "error") {
                    me.trigger("onDataError", response.msg)
                }
            });

        }

        initPaging() {
            this.grid.i18n.paging = {
                results: "Wyniki",
                records: "Wyniki od ",
                to: " do ",
                page: "Strona ",
                perpage: "Rekordów na stronie",
                first: "Pierwsza strona",
                previous: "Poprzednia strona",
                found: "Znalezionych rekordów ",
                next: "Następna strona",
                last: "Ostatnia strona",
                of: " z ",
                notfound: "Brak wyników"
            };
            this.grid.enablePaging(true, this.pageSize, 10, this.containerId + "-pagingbox", true);
            this.grid.setPagingSkin("bricks");
        }

        createHeaderConfiguration() {
            return this.columnDefinitionSource.getColumnDefinitions().map(function (columnDefinition) {
                const label = columnDefinition["label"];
                return '<div class="dhtmlx-grid-header-label" title="' + label + '">' + label + '</div>';
            }).join(",");
        }

        createColumnsConfiguration(index, mapping, defaultValue) {
            return this.columnDefinitionSource.getColumnDefinitions().map(function (columnDefinition) {
                const resolver = new NS.Utils.OptionsResolver(columnDefinition);
                const value = resolver.getOption(index, null);

                if (mapping[value]) {
                    return mapping[value];
                } else {
                    return value ? value : defaultValue;
                }
            }).join(",");
        }

        createColumnsAlignConfiguration() {
            return this.columnDefinitionSource.getColumnDefinitions().map(function (columnDefinition) {
                const dataType = columnDefinition.dataType;

                let align;

                switch (dataType) {
                    case "boolean":
                        align = "center";
                        break;
                    default:
                        align = "left";
                }

                return align;
            }).join(",");
        }

        createColumnsTypeConfiguration() {
            return this.columnDefinitionSource.getColumnDefinitions().map(function (columnDefinition) {
                let dataType;

                switch (columnDefinition.dataType) {
                    case "number":
                        dataType = columnDefinition.isEditable || columnDefinition.isEditableOnAdd ? "edn" : "ron";
                        break;
                    case "text":
                        dataType = columnDefinition.isEditable || columnDefinition.isEditableOnAdd ? "ed" : "rotxt";
                        break;
                    case "textarea":
                        dataType = columnDefinition.isEditable || columnDefinition.isEditableOnAdd ? "txt" : "txt";
                        break;
                    case "link":
                        dataType = columnDefinition.dataType;
                        break;
                    case "datetime":
                        dataType = columnDefinition.isEditable || columnDefinition.isEditableOnAdd ? "dhxCalendarA" : "rotxt";
                        break;
                    case 'boolean':
                        dataType = columnDefinition.isEditable || columnDefinition.isEditableOnAdd ? "boolean" : "boolean";
                        break;
                    case "actions":
                        dataType = columnDefinition.isEditable || columnDefinition.isEditableOnAdd ? "actions" : "actions";
                        break;
                    case "blocked":
                        dataType = columnDefinition.isEditable || columnDefinition.isEditableOnAdd ? "blocked" : "blocked";
                        break;
                    case "importants":
                        dataType = columnDefinition.isEditable || columnDefinition.isEditableOnAdd ? "importants" : "importants";
                        break;
                    case "reports":
                        dataType = columnDefinition.isEditable || columnDefinition.isEditableOnAdd ? "reports" : "reports";
                        break;
                    case "danger":
                        dataType = columnDefinition.isEditable || columnDefinition.isEditableOnAdd ? "danger" : "danger";
                        break;
                    case "download_status":
                        dataType = columnDefinition.isEditable || columnDefinition.isEditableOnAdd ? "download_status" : "download_status";
                        break;
                    default:
                        dataType = "ro";
                        break;
                }

                return dataType;
            }).join(",");
        }

        validateConfiguration() {
            if (!this.gridId) {
                throw new Error("Unknown this.grid control identifier. Provide 'id' value in configuration.");
            }
            if (!this.containerId) {
                throw new Error("Unknown this.grid control container DOM id. Provide 'this.containerId' value in configuration.");
            }
            if (this.columnDefinitionSource.count() === 0) {
                throw new Error("No column definitions.");
            }
            if (!this.dataSource) {
                throw new Error("No data source defined. Provide this.dataSource parameter (i.e. new NS.Grid.SimpleDataSource({ 'url': '/data.json'});");
            }
        }

        trigger(eventName, data) {
            if (this.listeners[eventName]) {
                data = data ? data : {};
                this.listeners[eventName].call(this, data);
            }
        }

        /**
         * Funkcja wczytuje dane inicjalne, aby uruchomić następnie tworzenie kontrolki
         */
        loadInitialData() {
            let leftToLoad = 2;
            const me = this;

            this.columnDefinitionSource.load(function () {
                leftToLoad--;

                if (leftToLoad === 0) {
                    me.afterInit();
                }
            });

            // noinspection JSUnusedLocalSymbols
            this.settingsManager.load(function () {
                leftToLoad--;

                if (leftToLoad === 0) {
                    me.afterInit();
                }
            }, function (msg) {
                leftToLoad--;
                if (leftToLoad === 0) {
                    me.afterInit();
                }
            });
        }

        afterInit() {
            this.validateConfiguration();

            this.createGrid();
            this.createDataProcessor();

            if (this.autoLoad) {
                this.load();
            }
            else {
                this.maskMe(false);
            }
        }


        //funkcje publiczne
        init(config) {
            this.gridId = config.id ? config.id : null;
            this.showAllRows = config.showAllRows || false;
            this.containerId = config.containerId ? config.containerId : null;
            this.dataSource = config.dataSource ? config.dataSource : null;
            this.reloadTime = config.reloadTime ? config.reloadTime : null;
            this.autoLoad = config.autoLoad ? config.autoLoad : false;
            this.pageSize = config.pageSize ? config.pageSize : this.pageSize;
            this.listeners = config.listeners ? config.listeners : {};
            this.columnDefinitionSource = config.columnDefinitionSource ? config.columnDefinitionSource : null;
            this.settingsManager = config.settingsManager ? config.settingsManager : null;
            this.allowMultiselect = config.allowMultiselect ? config.allowMultiselect : false;
            this.enableMultiline = config.enableMultiline ? config.enableMultiline : false;
            this.loadCallback = config.loadCallback ? config.loadCallback : null;

            this.prepareDom();
            this.loadInitialData();
        }

        createNewRecord(record) {
            const me = this;
            const newId = (new Date()).valueOf();

            const recordValues = [];

            for (let colIndex = 0; colIndex < this.columnDefinitionSource.count(); colIndex++) {
                const columnDefinition = this.columnDefinitionSource.getByIndex(colIndex);
                const columnDataIndex = columnDefinition.dataIndex;
                recordValues[this.grid.getColIndexById(columnDataIndex)] = record[columnDataIndex];
            }

            const firstEditableDataIndex = this.columnDefinitionSource.getFirstEditableDataIndex(/* newRecord = */ true);
            const firstEditableIndex = firstEditableDataIndex ? this.grid.getColIndexById(firstEditableDataIndex) : -1;

            this.grid.addRow(newId, recordValues, 0);
            this.grid.selectRow(0);

            if (firstEditableIndex >= 0) {
                this.grid.selectCell(0, firstEditableIndex, false, true);

                setTimeout(function () {
                    me.grid.editCell();
                }, 2);
            }
        }

        rowDelete() {
            this.grid.deleteRow("1");
        }

        saveChanges() {
            this.gridDataProcessor.sendData();
        }

        reload() {
            this.load();
        }

        /**
         * @deprecated
         */
        getGridObject() {
            return this.dhtmlxObject();
        }

        dhtmlxObject() {
            return this.grid;
        }
    }

    //wyeksportowanie klasy
    global.NS = global.NS || {};
    global.NS.Grid = global.NS.Grid || {};
    global.NS.Grid.Control = Control;
})(window);
